import type { AppTheme } from "./catalog";

export type ThemePalette = {
  primary: string;
  bgBase: string;
  bgLayout: string;
  bgContainer: string;
  bgElevated: string;
  text: string;
  textSecondary: string;
  border: string;
  icon: string;
  tableHeaderBg: string;
  siderBg: string;
  borderRadius: number;
};

/** Canonical colors per theme — tuned for readable text and icons on data-entry screens. */
export const THEME_PALETTES: Record<AppTheme, ThemePalette> = {
  light: {
    primary: "#1677ff",
    bgBase: "#ffffff",
    bgLayout: "#f5f5f5",
    bgContainer: "#ffffff",
    bgElevated: "#ffffff",
    text: "rgba(0, 0, 0, 0.88)",
    textSecondary: "rgba(0, 0, 0, 0.65)",
    border: "#d9d9d9",
    icon: "rgba(0, 0, 0, 0.65)",
    tableHeaderBg: "#fafafa",
    siderBg: "#f0f2f5",
    borderRadius: 4,
  },
  dark: {
    primary: "#1668dc",
    bgBase: "#141414",
    bgLayout: "#000000",
    bgContainer: "#141414",
    bgElevated: "#1f1f1f",
    text: "rgba(255, 255, 255, 0.85)",
    textSecondary: "rgba(255, 255, 255, 0.65)",
    border: "#424242",
    icon: "rgba(255, 255, 255, 0.65)",
    tableHeaderBg: "#141414",
    siderBg: "#001529",
    borderRadius: 4,
  },
  "solarized-light": {
    primary: "#268bd2",
    bgBase: "#fdf6e3",
    bgLayout: "#eee8d5",
    bgContainer: "#fdf6e3",
    bgElevated: "#fdf6e3",
    text: "#586e75",
    textSecondary: "#657b83",
    border: "#93a2a1",
    icon: "#657b83",
    tableHeaderBg: "#eee8d5",
    siderBg: "#eee8d5",
    borderRadius: 4,
  },
  "solarized-dark": {
    primary: "#268bd2",
    bgBase: "#002b36",
    bgLayout: "#073642",
    bgContainer: "#002b36",
    bgElevated: "#073642",
    text: "#93a2a1",
    textSecondary: "#839496",
    border: "#586e75",
    icon: "#93a2a1",
    tableHeaderBg: "#073642",
    siderBg: "#073642",
    borderRadius: 4,
  },
  "pastel-blue": {
    primary: "#3b6fbe",
    bgBase: "#f7fafd",
    bgLayout: "#e8f1fa",
    bgContainer: "#f7fafd",
    bgElevated: "#ffffff",
    text: "#1a3353",
    textSecondary: "#3d5a80",
    border: "#b8cfe8",
    icon: "#2c5282",
    tableHeaderBg: "#dce9f7",
    siderBg: "#dce9f7",
    borderRadius: 6,
  },
  "mac-silver": {
    primary: "#007aff",
    bgBase: "#f5f5f7",
    bgLayout: "#e8e8ed",
    bgContainer: "#f5f5f7",
    bgElevated: "#ffffff",
    text: "#1d1d1f",
    textSecondary: "#6e6e73",
    border: "#c8c8cc",
    icon: "#424245",
    tableHeaderBg: "#ececee",
    siderBg: "#ececee",
    borderRadius: 8,
  },
};
